import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { getGoogleStaticMapSrc } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  useHotelShopMap,
  type HotelShopMapComponentProps,
} from "@tenant/hotels";
import { Icon } from "@tenant/ui";
import styles from "./styles.module.scss";

export type HotelShopMapProps = HotelShopMapComponentProps & {
  icon?: IconNameEnum;
  apiKey?: string;
};

export const HotelShopMap: React.FC<HotelShopMapProps> = (
  props: HotelShopMapProps
) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.HotelShopMap);

  const { context, text } = useHotelShopMap(props);
  const { apiKey = import.meta.env.VITE_REACT_APP_GOOGLE_MAPS_API_KEY } = props;

  return (
    <div className={block}>
      <img
        className={cn("map")}
        src={getGoogleStaticMapSrc(
          context.coordinates,
          16,
          { width: 600, height: 1200 },
          2,
          true,
          context.markerColor,
          undefined,
          apiKey
        )}
        alt={t("hotelMapImageAlt", {
          hotelName: text.hotelName,
        })}
      />
      <div className={cn("label")}>
        <Icon
          className={cn("map-pin")}
          iconName={props.icon ?? IconNameEnum.mapPin}
          alt=""
        />
        <div className={cn("name")}>{text.hotelName}</div>
        <div className={cn("address")}>{text.address}</div>
      </div>
    </div>
  );
};
